// Tab-scoped Access/Refresh tokens — siehe operator-bootstrap.md.
const ACCESS_KEY = 'orbit.accessToken';
const REFRESH_KEY = 'orbit.refreshToken';

export const tokenStorage = {
  read() {
    try {
      return {
        accessToken: sessionStorage.getItem(ACCESS_KEY),
        refreshToken: sessionStorage.getItem(REFRESH_KEY),
      };
    } catch {
      return { accessToken: null, refreshToken: null };
    }
  },
  write({ accessToken, refreshToken }) {
    sessionStorage.setItem(ACCESS_KEY, accessToken);
    sessionStorage.setItem(REFRESH_KEY, refreshToken);
  },
  clear() {
    sessionStorage.removeItem(ACCESS_KEY);
    sessionStorage.removeItem(REFRESH_KEY);
  },
  keys: { access: ACCESS_KEY, refresh: REFRESH_KEY },
};
